
import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface DelinkConfirmationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  itemName: string;
  itemType: "merchant" | "store" | "user" | "member";
}

export const DelinkConfirmationDialog: React.FC<DelinkConfirmationDialogProps> = ({
  open,
  onOpenChange,
  onConfirm,
  itemName,
  itemType
}) => {
  const getActionText = () => {
    switch (itemType) {
      case "merchant":
        return "delink this merchant";
      case "store":
        return "delink this store";
      case "user":
        return "remove this user";
      case "member":
        return "remove this member";
      default:
        return "perform this action";
    }
  };

  const getDescription = () => {
    switch (itemType) {
      case "merchant":
        return `Are you sure you want to delink "${itemName}" from this program? This will remove all associated stores and may affect ongoing transactions.`;
      case "store":
        return `Are you sure you want to delink "${itemName}" from this program? This may affect ongoing transactions at this location.`;
      case "user":
        return `Are you sure you want to remove "${itemName}" from this program? They will lose access to program-specific features.`;
      case "member":
        return `Are you sure you want to remove "${itemName}" from this program? Their points and transaction history will be preserved but they will no longer be able to earn or redeem points.`;
      default:
        return `Are you sure you want to ${getActionText()}?`;
    }
  };

  const handleConfirm = () => {
    onConfirm();
    onOpenChange(false);
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Confirm {itemType === "merchant" || itemType === "store" ? "Delink" : "Removal"}</AlertDialogTitle>
          <AlertDialogDescription>
            {getDescription()}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => onOpenChange(false)}>
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction 
            onClick={handleConfirm}
            className="bg-red-600 hover:bg-red-700 focus:ring-red-600"
          >
            {itemType === "merchant" || itemType === "store" ? "Delink" : "Remove"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
